import {
  TreasuryBankAccountResponse,
  TreasuryBankAccountRequest,
} from "lib-klab-sdks";
import {
  BankAccount,
  BankAccountRequest,
} from "../../../domain/models/treasury/bank-account.model";

export function mapTreasuryBankAccount(dto: TreasuryBankAccountResponse): BankAccount {
  return {
    id: dto.id,
    supplierId: dto.supplierId,
    ownerUserId: dto.ownerUserId,
    bankId: dto.bankId,
    bankName: dto.bankName,
    accountNumber: dto.accountNumber ?? "",
    cci: dto.cci ?? "",
    currencyId: dto.currencyId,
    currencyCode: dto.currencyCode,
    accountHolder: dto.accountHolder ?? "",
    alias: dto.alias ?? "",
    lastPaymentDate: dto.lastPaymentDate,
    active: dto.active,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
}

export function mapTreasuryBankAccountRequest(
  request: BankAccountRequest,
): TreasuryBankAccountRequest {
  return {
    supplierId: request.supplierId,
    ownerUserId: request.ownerUserId,
    bankId: request.bankId,
    accountNumber: request.accountNumber,
    cci: request.cci,
    currencyId: request.currencyId,
    accountHolder: request.accountHolder,
    alias: request.alias,
    active: request.active,
  };
}
